import { store } from "../config/redux/store";

export const getProductCode = (productCode) => {
  const { system } = store.getState().optionReducer.config;
  if (system && productCode && system.new_product_codes) {
    const newCodes = JSON.parse(system.new_product_codes);
    if (newCodes[productCode]) {
      return newCodes[productCode];
    }
  }
  return productCode;
};
